import http from '../http/http';
import URL from '../constant/URL';

const {
  I,
  BRS_STEP_CODE_SEL,
  BRS_HO_CODE_SEL,
} = URL.API.PROGRESS_LEARNING;

// AI 바로셈 단계 코드 조회
export const brsStepCodeSelAPI = async () => {
  let result = null;
  await http.request({
    url: `${BRS_STEP_CODE_SEL}`,
    success: (resp) => { result = resp; },
    error: (error) => { throw error }
  });

  return result;
};

// AI 바로셈 호코드 조회
export const brsHoCodeSelAPI = async (brsStepCd) => {
  let result = null;
  await http.request({
    url: `${BRS_HO_CODE_SEL}/${brsStepCd}`,
    success: (resp) => { result = resp; },
    error: (error) => { throw error }
  });

  return result;
}

// 사용자 연계학습 AI바로셈 목록 조회
export const aiBarosamListSelAPI = async (data) => {
  const { brsStepCd, brsEditionCd, lrnMbrId, language } = data;
  let result = null;
  await http.request({
    url: `${I}/language/${language}/member/${lrnMbrId}/step/${brsStepCd}/edition/${brsEditionCd}`,
    success: (resp) => { result = resp; },
    error: (error) => { throw error; }
  });

  return result;
};

// 단원정보 조회 
export const unitInfoListSelAPI = async (eduCursCd) => {
  let result = null;
  await http.request({
    url: `${I}/language/KO/unit/curs/${eduCursCd}`,
    success: (resp) => { result = resp; },
    error: (error) => { throw error; }
  });

  return result;
}

// 교과수학 소주제 조회
export const mathematicsListAPI = async (data) => {
  const { lrnMbrId, language, eduCursCd, unitCd, unitNm } = data;
  let result = null;
  await http.request({
    url: `${I}/language/${language}/member/${lrnMbrId}/curs/${eduCursCd}/unit/${unitCd}?unitNm=${unitNm}`,
    success: (resp) => { result = resp; },
    error: (error) => { throw error; }
  });

  return result;
};

// 진도학습 검색 히스토리 저장 API
export const aiBarosamSearchHistoryReg = async (data) => {
  const { type, lrnMbrId } = data;
  let result = null;
  await http.request({
    url: `${I}/type/${type}/member/${lrnMbrId}`,
    data,
    method: http.METHOD.POST,
    success: (resp) => { result = resp; },
    error: (error) => { throw error; }
  });

  return result;
}

// 진도학습 검색 히스토리 조회
export const aiBarosamSearchHistorySel = async (data) => {
  const { type, lrnMbrId } = data;
  let result = null;
  await http.request({
    url: `${I}/type/${type}/member/${lrnMbrId}`,
    success: (resp) => { result = resp; },
    error: (error) => { throw error; }
  });

  return result;
}